export default __webpack_public_path__ + "static/media/Trailer.2f529cda.svg";